export const routes = (prefix = `lab`) => [
    {
        path: `/${prefix}/record-tests/:patientID/:visitNO`,
        name: `${prefix}.record-tests.create`,
        component: () => import('./Form.vue'),
        meta: {
            requiresAuth: true,
            permissions: {
                PageName: `${prefix}.record-tests.index`,
                PageDescription: "Lab: Record tests",
            },
        },
    },
    {
        path: `/${prefix}/record-tests/:patientID`,
        name: `${prefix}.record-tests.past-create`,
        component: () => import('./Form.vue'),
        meta: {
            requiresAuth: true,
            permissions: {
                PageName: `${prefix}.record-tests.index`,
                PageDescription: "Lab: Record tests",
            },
        },
    },
    
    {
        path: `/${prefix}/test-view-bar-code`,
        name: `${prefix}.test-view-bar-code`,
        component: () => import('./modals/ViewBarCode.vue'),
        meta: {
            requiresAuth: false,
            permissions: {
                PageName: `${prefix}.record-tests.index`,
                PageDescription: "Lab: Record tests",
            },
        },
    }
];